<template lang="pug">
  Tooltip.player-rating(is-vertical)
    slot
    template(v-slot:tooltip)
      .player-rating__tooltip {{ $t('ratingVVVTooltip') }}

</template>

<script>
import Tooltip from '~/components/Tooltip/Tooltip'

export default {
  name: 'RatingTooltip',

  components: { Tooltip }
}
</script>

<style lang="scss">
.player-rating {
  &__tooltip {
    @include body;

    max-width: 300px;
    padding: 16px;
    color: #fff;
  }
}
</style>
